import useModel from "./use-model";

export default () => {
  const model = useModel();
  return model.eagleModel.products;
};
